import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "admin-home"
};
import { useSidebarStore } from "@/store/sidebar";
import { useTagsStore } from "@/store/tags";
import AdminHeader from "@/components/admin/AdminHeader.vue";
import AdminSidebar from "@/components/admin/AdminSidebar.vue";
import AdminTags from "@/components/admin/AdminTags.vue";
import { useRouter } from "vue-router";
import { checkAdminSession } from "@/store/cache";
import { ref, watch } from "vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Home',
  setup(__props) {
    const sidebar = useSidebarStore();
    const tags = useTagsStore();
    const isLogin = ref(false);
    const contentHeight = window.innerHeight - 80;
    const store = useSharedStore();
    const theme = ref(store.theme);

    // 获取会话信息
    const router = useRouter();
    checkAdminSession().then(() => {
      isLogin.value = true;
    }).catch(() => {
      router.replace("/admin/login");
    });
    watch(() => store.theme, val => {
      theme.value = val;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return isLogin.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AdminSidebar), _createElementVNode("div", {
        class: _normalizeClass(["content-box", {
          'content-collapse': _unref(sidebar).collapse
        }])
      }, [_createVNode(AdminHeader), _createVNode(AdminTags), _createElementVNode("div", {
        class: _normalizeClass('content ' + theme.value),
        style: _normalizeStyle({
          height: contentHeight + 'px'
        })
      }, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "move",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
            include: _unref(tags).nameList
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
          _: 2
        }, 1024)]),
        _: 1
      })], 6)], 2)])) : _createCommentVNode("", true);
    };
  }
};